import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { ActiveCallWarningComponent } from 'shared/active-call-warning/active-call-warning.component'
import { WhatsappCallAudioSinkComponent } from 'shared/shared-chat/whatsapp-call-audio-sink/whatsapp-call-audio-sink.component'
import { WhatsappCallWidgetComponent } from 'shared/whatsapp-call-widget/whatsapp-call-widget.component'
import { ActiveCallWarningService } from 'src/app/services/active-call-warning.service'

@Component({
  selector: 'ht-whatsapp-calls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    WhatsappCallWidgetComponent,
    WhatsappCallAudioSinkComponent,
    ActiveCallWarningComponent,
  ],
  template: `
    <ht-whatsapp-call-widget />
    <whatsapp-call-audio-sink />
    <ht-active-call-warning />
  `,
})
export class WhatsappCallsComponent implements OnInit, OnDestroy {
  readonly activeCallWarningService = inject(ActiveCallWarningService)

  readonly beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    if (this.activeCallWarningService.isCalling()) {
      event.preventDefault()
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler)
  }

  ngOnInit() {
    //TODO: check if it's possible to terminate the active call if the page is refreshed/closed or in the refresh case reconnect
    this.preventLeavingPageOnActiveCall()
  }
  private preventLeavingPageOnActiveCall() {
    window.addEventListener('beforeunload', this.beforeUnloadHandler)
  }
}
